import { render, staticRenderFns } from "./HelpAndTournamentsModal.vue?vue&type=template&id=07d58a5c&"
import script from "./HelpAndTournamentsModal.vue?vue&type=script&lang=js&"
export * from "./HelpAndTournamentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports